import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {Button, Grid} from '@material-ui/core';
import {formShape} from 'rc-form';
import {FormErrors} from '../common';
import {useFormSubmitting} from 'hooks/forms';
import {formatErrors} from 'actions/errors';
import {addFlashMessage} from 'actions/flash-message';

const GreatForm = (props) => {
  const {
    form,
    className,
    submitFn,
    onSuccess,
    formatErrors,
    addFlashMessage,
    successMsg,
    renderSubmitButton,
    submitButtonProps,
    submitButtonText,
  } = props;
  const {submitting, errors, handleFormSubmit} = useFormSubmitting({
    submitFn,
    onSuccess,
    form,
    addFlashMessage,
    formatErrors,
    successMsg,
  });

  return (
    <form className={classNames(className)} onSubmit={handleFormSubmit}>
      <FormErrors errors={errors} />
      {props.children}
      {renderSubmitButton ? (
        renderSubmitButton({submitting, ...submitButtonProps})
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              disabled={submitting}
              {...submitButtonProps}
            >
              {submitButtonText}
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

GreatForm.propTypes = {
  children: PropTypes.node,
  form: formShape.isRequired,
  className: PropTypes.string,
  submitFn: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  formatErrors: PropTypes.func.isRequired,
  addFlashMessage: PropTypes.func.isRequired,
  successMsg: PropTypes.string.isRequired,
  renderSubmitButton: PropTypes.func,
  submitButtonProps: PropTypes.object.isRequired,
  submitButtonText: PropTypes.string.isRequired,
};

GreatForm.defaultProps = {
  submitButtonProps: {},
  submitButtonText: 'Save',
};

export default connect(null, {
  formatErrors,
  addFlashMessage,
})(GreatForm);
